export const IMAGES = [
  { src: "https://i.ibb.co/MkzdZHz/image1.png", thumbnail: "" },
  { src: "https://i.ibb.co/WVcTYDX/image2.png", thumbnail: "" },
];
